/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { api } from 'services';
import Dialog from 'react-bootstrap-dialog';
import MasterPage from 'components/MasterPage';
import ListingStatement from 'components/ListingStatement';
import { DashboardOutlined } from '@material-ui/icons';

const StatementsList = ({
  match: {
    params: { id }
  }
}) => {
  const defaultFilters = { currency_id: '1' };
  const [data, setData] = useState({ data: [] });

  const [filters, setFilters] = useState(defaultFilters);
  const [companyName, setCompanyName] = useState([]);
  const [rules, setRules] = useState([]);
  const [fiscalYears, setFiscalYears] = useState([]);
  const [period, setPeriod] = useState([]);
  const [currency, setCurrencies] = useState([]);

  let dialog;
  const { t } = useTranslation();

  useEffect(() => {
    api.get('companies/rules').then(({ data }) => setRules(data));
  }, []);

  useEffect(() => {
    api.get('currencies').then(({ data }) => setCurrencies(data));
  }, []);

  useEffect(() => {
    api
      .get('company-rules/fiscal-years')
      .then(({ data }) => setFiscalYears(data));
  }, []);

  useEffect(() => {
    api
      .get(`companies/${id}/period-types`)
      .then(({ data }) => setPeriod(data));
  }, [filters, id]);

  useEffect(() => {
    api.get(`statement/${id}`, { params: { ...filters } }).then(({ data }) => {
      setData(data);
      if (data.name) setCompanyName(data.name.alias);
    });
  }, [filters, id]);

  useEffect(() => {
    api
      .get(`statement/${id}`)
      .then(({ data }) => setCompanyName(data.name.alias));
  }, [id]);

  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters };

    if (reset) f = { ...defaultFilters, ...new_filters };

    setFilters(f);
  };

  return (
    <>
      <Card.Body className="shadow bg-white rounded mb-3">
        <Dialog
          ref={component => {
            dialog = component;
          }}
        />
        <Row>
          <Col className="d-flex mt-3 mb-3">
            <DashboardOutlined className="icon-title" />
            <h4 className="title-dashboard mt-2">
              {t('title:statement')} - {companyName}
            </h4>
          </Col>
        </Row>
        <Row className="mt-2">
          <Col>
            <Row className="mt-2">
              <Col>
                <ListingStatement
                  fields={[
                    { name: 'type', key: 'name', type: 'string' },
                    { name: 'MDF', key: 'mdf', type: 'currency' },
                    { name: 'BU', key: 'bu', type: 'currency' },
                    { name: 'own', key: 'own', type: 'currency' },
                    { name: 'extra', key: 'extra', type: 'currency' },
                    { name: 'total', key: 'total', type: 'currency' }
                  ]}
                  filters={[
                    {
                      name: 'fiscal year',
                      key: 'fiscal_year',
                      options: (() => {
                        return fiscalYears.map(fiscalYear => {
                          return {
                            label: fiscalYear.fiscal_year,
                            value: fiscalYear.fiscal_year
                          };
                        });
                      })()
                    },
                    {
                      name: 'period',
                      key: 'period_id',
                      options: (() => {
                        return period.map(periodData => {
                          return {
                            label:
                              periodData.period.type.name +
                              ' ' +
                              periodData.period.position,
                            value: periodData.period.id
                          };
                        });
                      })()
                    },
                    {
                      name: 'currency',
                      key: 'currency_id',
                      options: (() => {
                        return currency.map(currency => {
                          return {
                            label: currency.name,
                            value: currency.id
                          };
                        });
                      })()
                    }
                  ]}
                  stateFilters={filters}
                  setFilters={setFilters}
                  data={data}
                  handleFilterChange={handleFilterChange}
                  filter={filters}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Card.Body>
    </>
  );
};

const mapStateToProps = state => ({});

const reduxConnect = connect(mapStateToProps)(StatementsList);

export default MasterPage(reduxConnect);
